import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import classnames from 'classnames'
import { CallHistoryDropdownFilter } from 'pages/conversations/pages/calls/ui/CallHistoryDropdownFilter'
import { useCallHistoryContext } from 'pages/conversations/pages/calls/ui/CallHistory/context/callHistoryContext'
import { CallHistorySearch } from 'pages/conversations/pages/calls/ui/CallHistory/ui/web/CallHistorySearch/CallHistorySearch'
import styles from '../styles.module.scss'

type ICallHistoryHeaderProps = {
  isShowSearch?: boolean
}

export const CallHistoryHeader: FC<ICallHistoryHeaderProps> = observer(
  ({ isShowSearch = true }) => {
    const store = useCallHistoryContext()
    return (
      <div
        className={classnames(styles.header, {
          [styles.showSearch]: isShowSearch,
        })}
      >
        {isShowSearch && <CallHistorySearch />}
        <CallHistoryDropdownFilter store={store.filtersStore} />
      </div>
    )
  }
)
